import { defineStore } from "pinia";

export const useMedicalReasonStore = defineStore('medicalReason', {
    state: () => ({
        medicalReason: {},
        medicalReasons: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setMedicalReason(medicalReason) {
            this.medicalReason = medicalReason
        },
        setMedicalReasons(medicalReasons) {
            this.medicalReasons = medicalReasons
        },
        addMedicalReason(medicalReason) {
            this.medicalReasons.unshift(medicalReason)
        },
        updateMedicalReason(medicalReason) {
            let index = this.medicalReasons.findIndex(cl => cl.id === medicalReason.id)
            this.medicalReasons.splice(index, 1, medicalReason)
        },
        deleteMedicalReason(medicalReason) {
            let index = this.medicalReasons.findIndex(cl => cl.id === medicalReason.id)
            this.medicalReasons.splice(index, 1)
        },
    },
});